<template>
  <div id="app" :class="{
    'ru-lang-wrap': $i18n && $i18n.locale === 'ru',
    'en-lang-wrap': $i18n && $i18n.locale === 'en'
  }">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style lang="scss">
//俄语/英语下样式全局处理
.ru-lang-wrap, .en-lang-wrap {
  .el-form-item__label {
    line-height: 16px;
    white-space: pre-wrap;
    padding-top: 3px;
  }
  //.el-form-item__content {
  //  line-height: 18px;
  //}
  //表格按钮换行处理
  .el-table__cell .el-button, .form-inner-container .el-button {
    margin-bottom: 6px;
  }
  //步骤条文字换行处理
  .el-step__title {
    line-height: 18px;
    margin-top: 10px;
  }
  //表格内表单错误提示支持显示多行
  .el-table__body .el-table__cell .cell:has(.el-form-item__error) {
    overflow: visible;
  }
  //侧边栏二级菜单间距
  .sidebar-container .el-submenu .el-menu-item {
    padding: 0 40px 0 25px !important;
  }

  .el-menu--inline .sidebar-item-text {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue